import React from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { BillingPanelShell } from '@/features/billing/components/BillingPanel/Layouts'
import { PATH_BILLING } from '@/routes/const'
import { General, Subscriptions } from '../panel'

export const PanelRoot = () => {
  return (
    <Routes>
      <Route element={<BillingPanelShell />}>
        <Route index element={<General />} />
        <Route path={PATH_BILLING.SUBSCRIPTIONS} element={<Subscriptions />} />
      </Route>

      <Route path={'*'} element={<Navigate to={'/'} replace={true} />} />
    </Routes>
  )
}
